export function createAuthActions(deps) {
    const { firebase, onAfterEmailVerified } = deps;
    return {
        signIn: ({ email, password }) => firebase.signInWithPassword(email, password),
        signUp: ({ email, password, displayName }) => firebase.createAccount(email, password, displayName),
        fetchSignInMethods: ({ email }) => firebase.fetchSignInMethods(email),
        logout: () => firebase.signOut(),
        requestPasswordReset: ({ email }) => firebase.sendPasswordResetEmail(email),
        confirmPasswordReset: ({ code, newPassword }) => firebase.confirmPasswordReset(code, newPassword),
        async applyEmailVerification({ code }) {
            await firebase.applyEmailVerificationCode(code);
            // Firebase's reload doesn't fire onAuthStateChanged, so we ask the engine to re-evaluate.
            await onAfterEmailVerified();
        },
        resendEmailVerification: () => firebase.resendEmailVerification(),
        changePassword: ({ currentPassword, newPassword }) => firebase.changePassword(currentPassword, newPassword),
    };
}
